<template>
  <div id="app">
    <h1>Tic Tac Toe</h1>
    <div v-for="i in 3" :key="i">
      <tic-tac-toe-cell
        class="cell"
        v-for="j in 3"
        :key="j"
        :currentPlayer="currentPlayer"
        :gameActive="gameActive"
        @cellMarked="markCell(i, j)"
      ></tic-tac-toe-cell>
    </div>
    <p v-if="winner === ''">Current player: {{ currentPlayer }}</p>
    <p v-else>{{ winner }} wins!</p>
    
  </div>
</template>

<script>
import TicTacToeCell from './components/TicTacToeCell.vue'

export default {
  name: 'App',
  
  components: {TicTacToeCell},
  
  data() {
    return {
      currentPlayer: 'x',
      winner: '',

      cellMatrix: [
        ['empty', 'empty', 'empty'],
        ['empty', 'empty', 'empty'],
        ['empty', 'empty', 'empty'],
      ]
    };
  },

  computed: {
    gameActive() {return this.winner === ''},
  },

  methods: {
    markCell(i, j) {
      this.cellMatrix[i-1][j-1] = this.currentPlayer;
      if (this.checkGameOver()) this.winner = this.currentPlayer;
      this.changePlayer();
    },

    changePlayer() {
      this.currentPlayer = this.currentPlayer === 'x' ? 'o' : 'x';
    },

    checkGameOver() {
      return this.checkRows() || this.checkColumns() || this.checkDiagonals();
    },

    checkColumns() {
      const transposedMatrix = this.transposeMatrix(this.cellMatrix);
      return this.checkMatrix(transposedMatrix);
    },

    checkRows() {
      return this.checkMatrix(this.cellMatrix);
    },

    checkDiagonals() {
      const firstDiagonal = this.getDiagonal(this.cellMatrix);
      const mirroredMatrix = this.mirrorMatrix(this.cellMatrix);
      const secondDiagonal = this.getDiagonal(mirroredMatrix);
      return this.checkMatrix([firstDiagonal, secondDiagonal]);
    },

    checkMatrix(matrix) {
      return matrix.some(row => row.every(cell => cell !== 'empty' && cell === row[0]));
    },

    transposeMatrix(matrix) {
      return matrix[0].map((_, colIndex) => matrix.map(row => row[colIndex]));
    },

    mirrorMatrix(matrix) {
      return matrix.map(row => row.reverse());
    },

    getDiagonal(matrix) {
      return matrix[0].map((_, index) => matrix[index][index]);
    }
  }
}
</script>

<style>
#app {
  font-family: 'Courier New', Courier, monospace;
  text-align: center;
  box-sizing: border-box;
}
</style>
